/**
 * Speaker Bio Toggle
 */

import { initAccordion } from '../resources/scripts/accordion';

interface EventI18n {
  readMore: string;
  readLess: string;
}

declare global {
  interface Window {
    InteractEventData?: {
      i18n: EventI18n;
    };
  }
}

export function initSpeakerToggles(): void {
  const i18n = window.InteractEventData?.i18n ?? {
    readMore: 'Read more',
    readLess: 'Read less',
  };

  initAccordion({
    selector: '[data-speaker-toggle]',
    onToggle: (toggle, isExpanded) => {
      const text = isExpanded ? i18n.readLess : i18n.readMore;
      if (toggle.childNodes[0]) {
        toggle.childNodes[0].textContent = text + ' ';
      }
    },
  });
}
